export const LogoClipPath = () => {
  return (
    <svg
      style={{ position: "absolute", width: 0, height: 0 }}
      aria-hidden="true"
    >
      <defs>
        <clipPath id="cledar-logo-clip" clipPathUnits="objectBoundingBox">
          {/* Normalized paths to 0-1 range (original viewBox: 481 x 471 from monogram.svg) */}
          <path d="M0.232126 0.516354 C0.232210 0.491469 0.237095 0.466667 0.248877 0.445433 C0.261116 0.424070 0.278570 0.406144 0.301190 0.395663 L0.888849 0.126638 L0.890597 0.125508 L0.680595 0.007415 C0.668910 0.001801 0.658759 -0.001592 0.646284 0.000712 L0.098960 0.250342 C0.086683 0.255956 0.076235 0.262536 0.064987 0.270367 C0.025705 0.298480 0.002258 0.337187 0.001478 0.400626 C-0.000042 0.526029 -0.000904 0.647184 0.001395 0.784928 C0.004557 0.836108 0.027676 0.864593 0.068216 0.893344 C0.124277 0.931285 0.188395 0.963176 0.250875 0.999619 L0.251797 0.999574 C0.239372 0.980178 0.232126 0.956499 0.232126 0.932742 L0.232126 0.516354 Z" />
          <path d="M1.000000 0.660155 L0.414482 0.951102 L0.413624 0.739630 L0.832176 0.540314 L1.000000 0.660155 Z" />
        </clipPath>
      </defs>
    </svg>
  );
};
